export interface ValidationResult {
  isValid: boolean;
  error?: string;
}

export const validateEmail = (email: string): ValidationResult => {
  if (!email) {
    return { isValid: false, error: "Email is required" };
  }

  // Simple email validation: ensure basic format with @ and .
  const emailRegex = /^[^\s@]+@[^\s@.]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return { isValid: false, error: "Please enter a valid email address" };
  }

  return { isValid: true };
};

export const validatePhone = (phone: string): ValidationResult => {
  if (!phone) {
    return { isValid: false, error: "Phone number is required" };
  }

  // Remove all non-digit characters for validation
  const cleanPhone = phone.replace(/\D/g, "");

  if (cleanPhone.length < 10) {
    return { isValid: false, error: "Phone number must be at least 10 digits" };
  }

  if (cleanPhone.length > 15) {
    return {
      isValid: false,
      error: "Phone number must be no more than 15 digits",
    };
  }

  return { isValid: true };
};

export const validateRequired = (
  value: string,
  fieldName: string,
): ValidationResult => {
  if (!value || value.trim() === "") {
    return { isValid: false, error: `${fieldName} is required` };
  }

  return { isValid: true };
};

export const validateDate = (
  date: string,
  fieldName: string,
): ValidationResult => {
  if (!date) {
    return { isValid: false, error: `${fieldName} is required` };
  }

  const selectedDate = new Date(date);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  if (selectedDate < today) {
    return { isValid: false, error: `${fieldName} cannot be in the past` };
  }

  return { isValid: true };
};

export const validateDateRange = (
  arrivalDate: string,
  departureDate: string,
): ValidationResult => {
  if (!arrivalDate || !departureDate) {
    return { isValid: true }; // Individual date validation will handle required fields
  }

  const arrival = new Date(arrivalDate);
  const departure = new Date(departureDate);

  if (departure <= arrival) {
    return {
      isValid: false,
      error: "Departure date must be after arrival date",
    };
  }

  return { isValid: true };
};

export const formatPhoneNumber = (phone: string): string => {
  // Remove all non-digit characters
  const cleanPhone = phone.replace(/\D/g, "");

  // Format as international number if it doesn't start with +
  if (cleanPhone.length >= 10 && !phone.startsWith("+")) {
    return `+${cleanPhone}`;
  }

  return phone;
};
